import classnames from 'classnames/bind'

// libs
import { ProfileReducerActionTypesEnum, useProfileContext } from '@/components/pages/livemallclub/Profile/reducer'
import { useTranslation } from 'next-i18next'

// constants
import { VipShopType } from '@/api/fetchMemberVips'
import { TUserProfile } from '@/types/user-profile'

// components

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type TFollowInfoProps = {
  followers: TUserProfile[]
  followingMembers: TUserProfile[]
  vipClubMembers?: TUserProfile[] | VipShopType[]
}

const getFollowCountDisplay = (count: number) => {
  if (count >= 1000 && count < 1000000) {
    return `${(count / 1000).toFixed()}K`
  } else if (count >= 1000000) {
    return `${(count / 1000000).toFixed()}M`
  }
  return count
}

const SocialInfo = (props: TFollowInfoProps) => {
  const { followers, followingMembers = [], vipClubMembers = [] } = props
  const { t } = useTranslation()
  const hasFollowers = followers.length > 0
  const hasFollowingMembers = followingMembers.length > 0
  const hasVIP = vipClubMembers.length > 0
  const followersCount = hasFollowers ? followers.length : 0
  const followingMembersCount = hasFollowingMembers ? followingMembers.length : 0
  const vipClubMembersCount = hasVIP ? vipClubMembers.length : 0
  const { dispatch } = useProfileContext()
  const handleSocialInfoClick = () => {
    dispatch({ type: ProfileReducerActionTypesEnum.SET_SOCIAL_RELATIONS_OPEN, payload: true })
  }

  return (
    <div className={cx('social-info')} onClick={handleSocialInfoClick}>
      {hasFollowers && (
        <div className={cx('social-info-item')}>
          <div className={cx('social-info-item-count')}>{getFollowCountDisplay(followersCount)}</div>
          <div className={cx('social-info-item-text')}>{t('Common_Followers')}</div>
        </div>
      )}
      {hasFollowingMembers && (
        <>
          <div className={cx('divider')} />
          <div className={cx('social-info-item')}>
            <div className={cx('social-info-item-count')}>{getFollowCountDisplay(followingMembersCount)}</div>
            <div className={cx('social-info-item-text')}>{t('Common_Following')}</div>
          </div>
        </>
      )}
      {hasVIP && (
        <>
          <div className={cx('divider')} />
          <div className={cx('social-info-item')}>
            <div className={cx('social-info-item-count')}>{getFollowCountDisplay(vipClubMembersCount)}</div>
            <div className={cx('social-info-item-text')}>{t('Common_VIP')}</div>
          </div>
        </>
      )}
    </div>
  )
}
export default SocialInfo
